import {iFrameState} from "../../services/IFrameState.js";
import {PANEL_TYPE, DEFAULT_TRANSITION_TIME_MS} from "../../../blink-sdk/Constants.js";
import {DonationFlowHandler} from "./DonationFlowHandler.js";
import {SubscriptionFlowHandler} from "./SubscriptionFlowHandler.js";
import {GiftSubscriptionFlowHandler} from "./GiftSubscriptionFlowHandler.js";
import {iFrameConnection} from "../../services/IFrameConnection.js";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages.js";
import {ShopFlowHandler} from "./ShopFlowHandler.js";
import {Controller} from "./Controller.js";
import {DashboardFlowHandler} from "./DashboardFlowHandler.js";
import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {NewsletterFlowHandler} from "./NewsletterFlowHandler.js";
import {FUNCTIONALITY_NOT_ENABLED_URL} from "../PanelConstants.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {BaseFlowHandler} from "./BaseFlowHandler.js";
import {PaywallPurchaseFlowHandler} from "./PaywallPurchaseFlowHandler.js";
import {AuthFlowHandler} from "./AuthFlowHandler.js";


// We populate these objects only for autocomplete reasons. This object will be cleared in "initializeFlows".
// This gets used only in their corresponding flows (a flow state class doesn't instantiate in another flow).
export const Flow = {
    auth: new AuthFlowHandler(),
    donation: new DonationFlowHandler(),
    subscribe: new SubscriptionFlowHandler(),
    giftSubscription: new GiftSubscriptionFlowHandler(),
    payment: new PaywallPurchaseFlowHandler(),
    shop: new ShopFlowHandler(),
    dashboard: new DashboardFlowHandler(),
    newsletter: new NewsletterFlowHandler(),
    custom: new BaseFlowHandler(),
};

let PanelTypeToFlowHandlerClass = {};

for (const [key, value] of Object.entries(Flow)) {
    PanelTypeToFlowHandlerClass[key] = value.constructor;
}

let panelType = null;
let panelSkipCTA = null;
let panelEditRecurring = null;
let activeFlowHandler = null; // TODO @mustfix this is not yet a handler, need to be merged still
let clearTimeoutId = null;

function clearActiveFlow() {
    for (const key of Object.keys(Controller)) {
        Controller[key] = null;
    }
    for (const key of Object.keys(Flow)) {
        Flow[key] = null;
    }

    panelType = null;
    panelSkipCTA = null;
    panelEditRecurring = null;
    activeFlowHandler = null;
    clearTimeout(clearTimeoutId);
    clearTimeoutId = null;
}

function clearActiveFlowDelayed() {
    clearTimeoutId = setTimeout(clearActiveFlow, DEFAULT_TRANSITION_TIME_MS)
}

function makeFlowHandlerForPanelType(panelType) {
    const PanelHandlerClass = PanelTypeToFlowHandlerClass[panelType] || BaseFlowHandler;

    if (PanelHandlerClass === BaseFlowHandler) {
        panelType = PANEL_TYPE.custom;
    }

    // TODO @mustfix temp cludge to ensure we have all flows!
    for (const key of Object.keys(Flow)) {
        const FlowHandlerClass = PanelTypeToFlowHandlerClass[key] || BaseFlowHandler;
        Flow[key] = new FlowHandlerClass();
    }

    return Flow[panelType];
}

// TODO @mustfix this shit needs to be fixed ASAP, bug bomb
function updateActiveFlow() {
    const type = iFrameState.panelType;
    const {skipCTA, editRecurring} = iFrameState;
    if (!type || (panelType === type && panelSkipCTA === skipCTA && panelEditRecurring === editRecurring)) {
        return;
    }
    let newPanelType = type;
    let newPanelSkipCTA = skipCTA;
    let newPanelEditRecurring = editRecurring;
    if (newPanelType === PANEL_TYPE.empty) {
        // This needs to be done here too because first route change isn't dispatched.
        clearActiveFlowDelayed();
        return;
    }

    const merchant = iFrameMerchantService.getMerchant();
    if ((iFrameState.panelType === PANEL_TYPE.shop && !merchant.allowPurchases)
        || (iFrameState.panelType === PANEL_TYPE.donation && !merchant.allowDonations)
        || (iFrameState.panelType === PANEL_TYPE.subscribe && !merchant.allowSubscriptions)
        || (iFrameState.panelType === PANEL_TYPE.giftSubscription && !merchant.allowSubscriptions)
        || (iFrameState.panelType === PANEL_TYPE.newsletter && !merchant.allowEmailing)) {
        Router.changeURL(FUNCTIONALITY_NOT_ENABLED_URL);
        return;
    }

    if (clearTimeoutId) {
        clearActiveFlow();
    }
    panelType = newPanelType;
    panelSkipCTA = newPanelSkipCTA;
    panelEditRecurring = newPanelEditRecurring;

    activeFlowHandler = makeFlowHandlerForPanelType(panelType, true);

    activeFlowHandler.start();
}

export function initializeFlows() {
    clearActiveFlow();
    iFrameState.addUpdateListener(updateActiveFlow);
    updateActiveFlow();

    iFrameConnection.addListener(IFrameMessages.ROUTE_CHANGE, ({url}) => {
        if (url === PANEL_TYPE.empty) {
            clearActiveFlowDelayed();
        }
    });
}

export function GetActiveFlowHandler() {
    return activeFlowHandler;
}
